<div class="container">
    <div class="section-title">
        <h2>Preise – Führerscheinklasse B</h2>
        <div class="bar"></div>
        <p>Faire und transparente Preise – keine versteckten Kosten. Alle Preise verstehen sich inklusive 19 % MwSt.</p>
    </div>

    <div class="tab pricing-list-tab">
        <ul class="tabs">
            <li class="active"><a href="#">Einzelpreise</a></li>
        </ul>

        <div class="tab_content">
            <!-- Einzelpreise -->
            <div class="tabs_item active">
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Grundbetrag</h3>
                            </div>
                            <div class="price">
                                <sup>€</sup>350
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Inklusive Lern-App</li>
                                <li><i class="fas fa-check"></i> Theorieunterricht (14 Einheiten)</li>
                                <li><i class="fas fa-check"></i> Persönliche Betreuung</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Fahrstunden</h3>
                            </div>
                            <div class="price">
                                <sup>€</sup>75 <sub>/45 Min</sub>
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Übungsfahrt: €75</li>
                                <li><i class="fas fa-check"></i> Sonderfahrt: €75</li>
                                <li><i class="fas fa-check"></i> Flexible Terminvereinbarung</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Prüfungen & Materialien</h3>
                            </div>
                            <div class="price">
                                <sup>ab €</sup>75
                            </div>
                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Theorieprüfung: €95</li>
                                <li><i class="fas fa-check"></i> Praktische Prüfung: €215</li>
                                <li><i class="fas fa-check"></i> Lernmaterial inklusive</li>
                                <li><i class="fas fa-times"></i> TÜV-Gebühr nicht enthalten</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
